// extracted by mini-css-extract-plugin
export default {"container":"SuccessContainer_container__+x8fn"};